export const DEFAULT_NAME_VALUES = {
    FIRST_NAME: 'First_Name',
    LAST_NAME: 'Last_Name',
};
